/**
 * The paid add-ons that bring the rest of Mia-Platform to the sandbox (sandbox-first, docs/SANDBOX_FIRST.md), as
 * Features › Connections shows them. Whether each one is on for the person comes from the sandbox overview's
 * `connections` (`{ aiFoundry: { enabled, included }, ... }`): `enabled` by the organization, `included` in the
 * person's plan. Any of them may be missing on an older vfs-service.
 */
export const CONNECTIONS = [
  {
    key: 'aiFoundry',
    name: 'AI Foundry',
    tagline: 'Your company’s agents platform',
    gets: [
      'Playbooks: the company’s proven ways to build, in Flow’s chat and in your AI tool',
      'Observability: every agent run traced, with cost and quality',
      'Company MCP servers (Jira, GitLab, internal APIs) offered to your AI tool through the sandbox',
      'The organization’s models for Chat',
    ],
    where: 'Chat, your AI tool’s tools, project Activity',
  },
  {
    key: 'contextCatalog',
    name: 'Context Catalog',
    tagline: 'The company’s data, APIs and documents as context',
    gets: [
      'Search and read the catalog from your AI tool and from Chat',
      'Ground what you build on real company APIs and data models',
      'Reached through the playbook MCP server',
    ],
    where: 'your AI tool’s tools, Chat',
    needs: 'Needs AI Foundry: Context Catalog is reached through its playbook MCP server.',
  },
  {
    key: 'console',
    name: 'Console',
    tagline: 'Production environments for what you build',
    gets: [
      'Link a project to a Console project',
      'Publish gets a Production target, through Console’s pipelines and approvals',
      'See what runs in each environment from the project',
    ],
    where: 'Publish, the project dashboard',
  },
  {
    key: 'fastData',
    name: 'Fast Data',
    tagline: 'Data products your apps can use',
    gets: [
      'Configure a data product (sources, projections, single views) from a project',
      'Your services read it as an API, in preview and in production',
      'Ask your AI tool to wire it in: it sees the data product’s schema',
    ],
    where: 'the project dashboard, your AI tool’s tools',
  },
];

/**
 * One connection's state for the person: 'included' (enabled and in their plan), 'not-in-plan' (enabled, not in their
 * plan), 'org-off' (not enabled by the organization), or null when the overview does not say.
 */
export function connectionState(sandbox, key) {
  const entry = sandbox?.connections?.[key];
  if (!entry || typeof entry !== 'object') { return null; }
  if (entry.enabled === false) { return 'org-off'; }
  if (entry.enabled === true) { return entry.included ? 'included' : 'not-in-plan'; }
  return null;
}

/** How many connections the person's plan includes (what the sidebar shows next to Connections). */
export function includedConnections(sandbox) {
  return CONNECTIONS.filter((item) => connectionState(sandbox, item.key) === 'included').length;
}
